module.exports = __webpack_public_path__ + "agora.5e3ee077.png";